import { css } from "@emotion/core";
import { color, fontTypes } from "../../constants/commons";

export const notFoundErrorContainer = (isMobile: boolean) => css`
  display: flex;
  background: white;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 1em;

  .error-text {
    .four-o-four {
      font-family: ${fontTypes.bold};
      letter-spacing: 0px;
      font-weight: bold;
    }
    .not-found {
      font-family: ${fontTypes.bold};
      font-weight: bold;
    }
    .text {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
      font-weight: normal;
    }
  }

  ${isMobile &&
  `
  .error-rangoon {
    height: 30vh;
  }
  .error-text {
    text-align: center;
    .four-o-four {
      font-size: 2.5em;
    }
    .not-found {
      font-size: 1.13em;
    }
    .text {
      font-size: 0.87em;
    }
  }
  .home-button {
    margin-top: 3.1em;
  }
  `}

  ${!isMobile &&
  `
  align-items: center;
  .error-rangoon {
    width: 100%;
    max-width: 70em;
  }
  .error-text {
    position: absolute;
    bottom: 60%;
    left: 25vw;
    max-width: 18.75em;
    .four-o-four {
      font-size: 4.5em;
    }
    .not-found {
      font-size: 1.5em;
    }
    .text {
      font-size: 1em;
    }
  }
  .home-button {
    margin-top: 1.25em;
  }
  `}
`;
